import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faPencil,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import useProfessionalInformation from "./useProfessionalInformation";
import { SkillSearchInput } from "../../../../_uiComponents/Search/SkillSearchInput";
import LocationBasic from "../../../../_uiComponents/LocationBasic";
import { dateFormatter } from "../../../../_helpers/dateFormatter";

export default (props) => {
  const {
    allProfessionalData,
    loadingprofession,
    professionFormData,
    editProfessionItemId,
    professionEndDate,
    professionStartDate,
    newProfessionAdded,
    companyIndustry,
    employmentType,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onCurrentlyWorking,
    onProfessionFormDataChange,
    onEditProfessionItemClick,
    onEditProfessionCancelClick,
    onAddNewProfessionClick,
    onSubmitForm,
    deleteUserExperience,
    onLocationChange,
    cancelNewProfessional,
  } = useProfessionalInformation(props);

  return (
    <div className="hiring-process-dashboard  hiring-manager-profile-wrapper">
      <div className="job-detail-wrapper mt-4 pr-lg-4">
        <Container>
          <Row>
            <div className="col-md-8 bg-white border border-radius-10 p-4">
                <h2 className="mb-3">Work Experience</h2>

              <div>
                {loadingprofession ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  allProfessionalData &&
                  Array.isArray(allProfessionalData) &&
                  allProfessionalData.map((item) => (
                      <div className="py-2">
                        {editProfessionItemId === item?.id ||
                        item.id === undefined ? (
                          <Row>
                            <Col lg={5}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Job
                                  Title
                                </p>
                                <input
                                  className="form-control mw-100 text-capitalize"
                                  type="text"
                                  placeholder="Enter your Job Title"
                                  name={"job_title"}
                                  defaultValue={professionFormData?.job_title}
                                  onChange={onProfessionFormDataChange}
                                />
                              </div>
                            </Col>

                            <Col lg={5}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  <span className="text-danger">* </span>Company
                                  Name
                                </p>
                                <input
                                  className="form-control mw-100 text-capitalize"
                                  type="text"
                                  placeholder="Enter your Company Name"
                                  name={"company"}
                                  defaultValue={
                                    professionFormData?.company_name
                                  }
                                  onChange={onProfessionFormDataChange}
                                />
                              </div>
                            </Col>

                            <Col lg={5}>
                              <div className="form-group">
                                <p className="font-weight-medium">Industry</p>
                                <span className="select">
                                  <select
                                    className="form-control"
                                    onChange={(e) =>
                                      onProfessionFormDataChange(e)
                                    }
                                    name={"industry"}
                                  >
                                    <option
                                      disabled={true}
                                      value=""
                                      selected={
                                        professionFormData?.industry ===
                                        undefined
                                      }
                                    >
                                      Select company industry
                                    </option>
                                    {Array.isArray(companyIndustry) &&
                                      companyIndustry.map((i, index) => (
                                        <option
                                          selected={
                                            professionFormData?.industry ===
                                            i.value
                                          }
                                          key={index}
                                          value={i.value}
                                        >
                                          {i.key}
                                        </option>
                                      ))}
                                  </select>
                                </span>
                              </div>
                            </Col>
                            <Col lg={5}>
                              <div className="form-group">
                                <p className="font-weight-medium">
                                  Employment Type
                                </p>
                                <span className="select">
                                  <select
                                    className="form-control"
                                    onChange={(e) =>
                                      onProfessionFormDataChange(e)
                                    }
                                    name={"employment_type"}
                                    placeholder=" Select Employment Type"
                                  >
                                    <option
                                      disabled={true}
                                      value=""
                                      selected={
                                        professionFormData?.employment_type ===
                                        undefined
                                      }
                                    >
                                      Select Employment Type
                                    </option>
                                    {Array.isArray(employmentType) &&
                                      employmentType.map((i, index) => (
                                        <option
                                          key={index}
                                          selected={
                                            professionFormData?.employment_type ===
                                            i.value
                                          }
                                          value={i.value}
                                        >
                                          {i.key}
                                        </option>
                                      ))}
                                  </select>
                                </span>
                              </div>
                            </Col>

                            <Col lg={5}>
                              <div className="form-group">
                                <p className="font-weight-medium">Start Date</p>
                                <DatePicker
                                  dateFormat="yyyy-mm-dd"
                                  value={professionStartDate}
                                  onChange={(date) => {
                                    onProfessionFormDataChange({
                                      target: {
                                        value: date,
                                        name: "start_date",
                                      },
                                    });
                                  }}
                                  className="form-control"
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  placeholderText={
                                    professionStartDate
                                      ? professionStartDate
                                      : "Select Start Date"
                                  }
                                />
                              </div>
                            </Col>

                            <Col
                              lg={5}
                              className={` ${
                                professionFormData?.currently_working_here ===
                                true
                                  ? "d-none"
                                  : "d-block"
                              }`}
                            >
                              <div className="form-group">
                                <p className="font-weight-medium">End Date</p>
                                <DatePicker
                                  dateFormat="yyyy-mm-dd"
                                  onChange={(date) => {
                                    onProfessionFormDataChange({
                                      target: {
                                        value: date,
                                        name: "end_date",
                                      },
                                    });
                                  }}
                                  className="form-control"
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  value={professionEndDate}
                                  placeholderText={
                                    professionEndDate
                                      ? professionEndDate
                                      : "Select End Date"
                                  }
                                />
                              </div>
                            </Col>
                            <Col
                              lg={12}
                              className="checkbox custom-control custom-checkbox mb-2 ml-3"
                            >
                              <div
                                className={`custom-control-input  pl-lg-5 pl-md-4 ${
                                  professionFormData?.currently_working_here ===
                                  true
                                    ? "active"
                                    : " "
                                }`}
                                id="currently working"
                                onClick={onCurrentlyWorking}
                                name={"currently_working_here"}
                              ></div>
                              <label
                                className="custom-control-label text-grey-4"
                                htmlFor="currentlyWorking"
                              >
                                I am currently working in this role
                              </label>
                            </Col>
                            <Col lg={10}>
                              <div className="form-group mt-3">
                                <p className="font-weight-medium">
                                  <span className="text-danger"></span>
                                  Description
                                </p>
                                <input
                                  className="form-control mw-100 text-capitalize"
                                  type="text"
                                  placeholder="Enter your Description"
                                  name={"description"}
                                  defaultValue={professionFormData?.description}
                                  onChange={onProfessionFormDataChange}
                                />
                              </div>
                            </Col>
                            <Col lg={10} className="">
                              <div className="form-group">
                                <p className="font-weight-medium mb-1">
                                  Skills
                                </p>
                                <div className="p-4 rounded-lg border mw-100">
                                  <div className="d-flex flex-wrap align-items-center">
                                    {professionFormData?.skills &&
                                      Array.isArray(
                                        professionFormData?.skills
                                      ) &&
                                      professionFormData.skills.map(
                                        (tag, index) => (
                                          <div
                                            className="h4 bg-grey-3 py-1 rounded font-weight-normal text-dark px-2 mr-2 text-capitalize mb-3"
                                            onClick={() =>
                                              onKeywordsTagsDelete(tag)
                                            }
                                            key={index}
                                          >
                                            {tag}
                                            <FontAwesomeIcon
                                              icon={faXmark}
                                              className="ml-3"
                                            />
                                          </div>
                                        )
                                      )}
                                  </div>
                                  <SkillSearchInput
                                    className="form-control"
                                    placeholder="Search Skill..."
                                    onSearchSelect={(item) =>
                                      onKeywordsTagsAddition(item)
                                    }
                                    clearSearch={true}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col lg={10} className="mb-3">
                              <LocationBasic
                                onLocationChange={(name, value) =>
                                  onLocationChange(name, value)
                                }
                                country={professionFormData?.country_name}
                                state={professionFormData?.state_name}
                                city={professionFormData?.city_name}
                              />
                            </Col>

                            <Col lg={12}>
                              <div className="form-group d-flex align-items-center mt-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={() => onSubmitForm()}
                                >
                                  Save
                                </button>
                                {item?.id && (
                                  <button
                                    className="btn btn-light ml-3"
                                    onClick={onEditProfessionCancelClick}
                                  >
                                    Cancel
                                  </button>
                                )}
                                {newProfessionAdded && !item.id && (
                                  <button
                                    className="btn btn-light ml-3"
                                    onClick={cancelNewProfessional}
                                  >
                                    Cancel
                                  </button>
                                )}
                                {item?.id && (
                                  <button
                                    className="border-0 bg-transparent text-danger ml-auto"
                                    onClick={() =>
                                      deleteUserExperience(item.id)
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faMinusCircle}
                                      className="mr-2"
                                    />
                                    Delete Profession
                                  </button>
                                )}
                              </div>
                            </Col>
                          </Row>
                        ) : (
                          <div className="border border-radius-10 p-4 bg-grey-5  text-capitalize">
                          <div className="d-flex align-items-start justify-content-between">
                            <div>
                              <h3 className="font-weight-medium fs-20 mb-1">{item?.job_title}</h3>
                              <p className="text-grey-4">{item?.company_name}</p>
                              <span className="text-grey-4 mr-2">{item?.industry.replace(/_/g, " ")}</span>{"|"}{" "}
                              <span className="text-grey-4">{dateFormatter(item?.start_date)}</span> -
                              {item?.currently_working_here === true ? 
                              <span className="text-grey-4"> Currently Working</span> :
                                <span className="text-grey-4"> {dateFormatter(item?.end_date)}</span>
                              }
                            </div>
                            <FontAwesomeIcon
                              icon={faPencil}
                              className="text-grey-4 cursor-pointer"
                              onClick={() => onEditProfessionItemClick(item?.id)}
                            />
                          </div>
                        </div>
                        )}
                      </div>
                  ))
                )}

                {!newProfessionAdded && (
                  <p
                    className="text-primary cursor-pointer font-weight-medium mt-2"
                    onClick={() => onAddNewProfessionClick()}
                  >
                    + Add new work experience
                  </p>
                )}
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  );
};
